import React from "react"
import moment from "moment"

export default ({text}) => (
  <span className="date">{moment(text).format("YYYY.M.D H:mm")}</span>
)